import { render, staticRenderFns } from "./TaskInfoModalActivity.vue?vue&type=template&id=37151b33"
import script from "./TaskInfoModalActivity.vue?vue&type=script&lang=js"
export * from "./TaskInfoModalActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports